import React, {ReactElement} from 'react';
import {Draggable} from '@hello-pangea/dnd';
import {useSelector} from 'react-redux';
import {useAddElementAction} from '../../../../context/AddElementsContext';
import {useSlideErrors} from '../../../../context/SlideErrorsContext';
import {useHotkeysSlideElementKeys} from '../../../../hooks/useHotkeysSlideElementKeys';
import {IElement} from '../../../../incase-domain/elements';
import {isCoverHtmlElement} from '../../../../incase-domain/elements/html';
import {selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import ElementMobile from '../../../elements/elementMobile';

interface ElementsMobileProps {
    slideId: string;
    elements: IElement[];
    onOptions: (id: string, silent?: boolean) => void;
}

function ElementsMobile({slideId, elements, onOptions}: ElementsMobileProps): ReactElement {
    const slide = useSelector(selectedSlideSelector);

    const {errors} = useSlideErrors();
    const addElement = useAddElementAction();

    useHotkeysSlideElementKeys((type) => addElement(type));

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                minHeight: 0,
                gap: `${slide.gapBetweenMobileElements}em`,
                paddingTop: `${slide.elementPadding?.top}em`,
                paddingRight: `${slide.elementPadding?.right}em`,
                paddingBottom: `${slide.elementPadding?.bottom}em`,
                paddingLeft: `${slide.elementPadding?.left}em`,
            }}
        >
            {elements.map((element, index) => {
                const coverSlide = isCoverHtmlElement(element);
                const keyIndex = `slide-${slideId}-element-${element.id || index}`;
                const slideErrors = errors ? errors.errors : {};
                const hasErrors =
                    (slideErrors?.elements &&
                        Array.isArray(slideErrors.elements) &&
                        slideErrors.elements[0] &&
                        Object.keys(slideErrors.elements[0]).includes(element.id)) ||
                    undefined;

                return (
                    <div
                        key={keyIndex}
                        style={
                            coverSlide
                                ? {touchAction: 'none', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}
                                : {touchAction: 'none'}
                        }
                    >
                        <Draggable key={`element-draggable-mobile-${element.id}`} draggableId={element.id} index={index}>
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={`mobile-element-pos-${index}`}
                                    style={{
                                        ...provided.draggableProps.style,
                                        ...(coverSlide
                                            ? {flex: 1, minHeight: 0, height: '100%', marginBottom: 0}
                                            : {marginBottom: '1.41em'}),
                                    }}
                                >
                                    <ElementMobile
                                        element={{
                                            ...element,
                                            keyIndex,
                                        }}
                                        elementIndex={index}
                                        onOptions={onOptions}
                                        hasError={hasErrors}
                                    />
                                </div>
                            )}
                        </Draggable>
                    </div>
                );
            })}
        </div>
    );
}

export default ElementsMobile;
